import { render } from "./Schedule.vue?vue&type=template&id=5ac38a32"
import script from "./Schedule.vue?vue&type=script&lang=js"
export * from "./Schedule.vue?vue&type=script&lang=js"

import "./Schedule.vue?vue&type=style&index=0&id=5ac38a32&lang=scss"

import exportComponent from "/Users/sarah.veysset/S/TRAVAIL/FREELANCE/OSTEO BARRY/osteo-barry/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__